export default {

    defaultStringDate: "0001-01-01T00:00:00"
    
}